var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCreditNote(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.94,
    height: 20.009,
    viewBox: "0 0 20.94 20.009",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "_1",
    "data-name": 1,
    d: "M8.686,11.952H3.517C1.474,11.952.75,12.67.75,14.7v3.816c0,2.024.724,2.742,2.767,2.742H8.686c2.047,0,2.767-.718,2.767-2.742V14.7C11.452,12.67,10.728,11.952,8.686,11.952Zm1.371,6.561c0,1.245-.1,1.346-1.371,1.346H3.517c-1.268,0-1.371-.1-1.371-1.346v-1.85h7.91Zm0-3.25H2.146V14.7c0-1.246.1-1.347,1.371-1.347H8.686c1.268,0,1.371.1,1.371,1.347Zm10.7-1.217a7.221,7.221,0,0,1-7.212,7.212.7.7,0,0,1-.6-1.057l.977-1.629a.7.7,0,1,1,1.2.718l-.251.42a5.828,5.828,0,0,0,4.492-5.665.7.7,0,1,1,1.4,0ZM.75,8.462A7.221,7.221,0,0,1,7.962,1.25a.7.7,0,0,1,.6,1.057L7.585,3.936a.7.7,0,1,1-1.2-.718l.251-.42A5.828,5.828,0,0,0,2.146,8.462a.7.7,0,0,1-1.4,0ZM16.8,11.022a4.886,4.886,0,1,0-4.885-4.886A4.886,4.886,0,0,0,16.8,11.022Zm0-8.376a3.49,3.49,0,1,1-3.489,3.49A3.49,3.49,0,0,1,16.8,2.646Z",
    transform: "translate(-0.75 -1.25)",
    fill: "#363636"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditNote);
export default __webpack_public_path__ + "static/media/Credit Note.e95eaec2327e23331f951afb224f7795.svg";
export { ForwardRef as ReactComponent };